import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICancelOrderPayload {
    id: string
    data?: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const cancelOrder = createSlice({
    name: 'order/cancel',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ICancelOrderPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const cancelOrderActions = cancelOrder.actions
export default cancelOrder.reducer
